export default {
  'types': ['geocode'],
  'componentRestrictions': { 'country': ['cz', 'sk'] },
};
